import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useRouteParams } from "@vueuse/router";
import { useMetadataExperienceApi } from "@/composables/useMetadataExperienceApi";
import type { BookingInformation } from "@/types/generated/MetadataExperiencesApi";

export const BOOKING_INFORMATION_QUERY_KEY = "booking-information";

export interface BookingInformationQueryData {
  id: string;
  bookingInformation: BookingInformation;
}

export function useBookingInformationQuery(experienceId: Ref<string>) {
  const { getBookingInfo } = useMetadataExperienceApi();

  return useQuery({
    queryKey: [BOOKING_INFORMATION_QUERY_KEY, experienceId],
    queryFn: async (): Promise<BookingInformationQueryData | null> => {
      const { data } = await getBookingInfo(experienceId.value);
      const bookingInfo = data[0];

      if (!bookingInfo?.id) {
        return null;
      }

      return {
        id: bookingInfo.id,
        bookingInformation: bookingInfo.booking_information,
      };
    },
    enabled: computed(() => !!experienceId.value),
  });
}

export function useCurrentBookingInformationQuery() {
  const experienceId = useRouteParams<string>("id");
  return useBookingInformationQuery(experienceId);
}
